import styled from 'styled-components'

export const AddressWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

export const ORLine = styled.h2`
	width: 100%;
	text-align: center;
	border-bottom: 1px solid white;
	line-height: 0px;
	background: transparent;
`

export const ORWord = styled.span`
	background: #e0424f;
	color: white;
	font-size: 12px;
	border-radius: 10px;
`
export const LoaderWrapper = styled.div`
	position: absolute;
	height: 50vh;
	width: 100%;
	background: #000;
	opacity: 0.3;
	border-radius: 10px;
	pointer-events: none;
`
